/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNotification } from '@/containers'
import { useClickOutsideComponent } from '@/utils/useClickOutsideComponent'
import DrawChat from '../DrawChat'
import { IconChat } from '../Icon/IconChat'
import { IconChatClose } from '../Icon/IconChatClose'
import { IconZalo } from '../Icon/IconZalo'

export function PopupChat() {
  const { systemConfig } = useNotification()
  const { ref, isComponentVisible, setIsComponentVisible } =
    useClickOutsideComponent(false)
  return (
    <>
      <DrawChat
        refer={ref || null}
        open={isComponentVisible}
        onClose={() => setIsComponentVisible(false)}
      >
        <div className='flex text-base justify-end absolute bottom-[80px] flex-col gap-y-2 right-2'>
          <a
            href={systemConfig?.warehouseMessage}
            target='_blank'
            className='messenger flex items-center justify-end'
          >
            <svg
              width='50'
              height='51'
              viewBox='0 0 50 51'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g clipPath='url(#clip0_19383_31558)'>
                <path
                  d='M25 0.129862C11.4901 -0.136519 0.310907 10.5769 0.00244141 24.0858C0.0376919 30.9624 3.08261 37.4788 8.33493 41.9174V49.0834C8.33493 49.6586 8.80129 50.125 9.37653 50.125C9.57172 50.125 9.76301 50.0701 9.92852 49.9667L15.7342 46.34C18.6921 47.4713 21.8331 48.0482 25 48.0419C38.5099 48.3083 49.6891 37.5949 49.9976 24.0859C49.6891 10.5769 38.5099 -0.136519 25 0.129862Z'
                  fill='#2196F3'
                />
                <path
                  d='M41.4568 17.2115C41.1469 16.7961 40.5786 16.6718 40.1236 16.9198L29.2914 22.8255L22.5525 17.0469C22.1392 16.6926 21.5229 16.7161 21.1381 17.101L8.63928 29.5998C8.23376 30.0078 8.23571 30.6673 8.64377 31.0728C8.97001 31.3971 9.47026 31.469 9.87461 31.2497L20.7069 25.344L27.452 31.1247C27.8652 31.4789 28.4816 31.4554 28.8664 31.0705L41.3652 18.5717C41.7294 18.2041 41.7685 17.6247 41.4568 17.2115Z'
                  fill='#FAFAFA'
                />
              </g>
              <defs>
                <clipPath id='clip0_19383_31558'>
                  <rect
                    width='50'
                    height='50'
                    fill='white'
                    transform='translate(0 0.125)'
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
          <div className='flex w-12 cursor-pointer flex-col items-center justify-center overflow-hidden rounded-full py-1 text-center'>
            <a
              href={`${systemConfig?.warehouseZalo || ''}`}
              target='_blank'
              rel='noreferrer'
            >
              <IconZalo
                className={
                  'h-[50px] w-[50px] overflow-hidden rounded-full object-cover '
                }
              />
            </a>
          </div>

          <div className='flex w-full cursor-pointer flex-col items-center justify-center rounded-full py-1 text-center'>
            <a
              href='tel:0904881179'
              target='_blank'
              rel='noreferrer'
              className='relative'
            >
              <div className='absolute right-1 top-1/2 flex h-10 -translate-y-1/2 items-center whitespace-nowrap rounded-full bg-primary-base pl-4 pr-14 font-semibold text-white'>
                090 4881179
              </div>
              <svg
                width='50'
                height='50'
                viewBox='0 0 47 47'
                fill='none'
                className='relative z-10 block'
                xmlns='http://www.w3.org/2000/svg'
              >
                <circle cx='23.9238' cy='23.125' r='23' fill='white' />
                <path
                  d='M30.2469 24.7249C29.8279 24.306 29.1158 24.306 28.6969 24.7249L26.2671 27.1547C25.136 28.2858 22.5806 27.5317 20.5279 25.479C18.4752 23.4263 17.7212 20.8709 18.8523 19.7398L21.282 17.3101C21.7009 16.8912 21.7009 16.179 21.282 15.7601L15.7104 10.1885C15.2914 9.76954 14.5793 9.76954 14.1604 10.1885L12.5266 11.8222C9.25902 15.0898 11.4374 22.5885 17.4279 28.579C23.4185 34.5695 30.9171 36.7898 34.1847 33.4803L35.8185 31.8466C36.2374 31.4276 36.2374 30.7155 35.8185 30.2966L30.2469 24.7249Z'
                  fill='#FF4B32'
                />
                <path
                  d='M24.5495 8.21957C24.0049 8.17767 23.586 8.63848 23.6279 9.22497C23.6698 9.64389 24.0887 9.97902 24.5076 10.0209C30.7076 10.4398 35.6509 15.425 36.0698 21.625C36.1117 22.0858 36.4887 22.4628 36.9495 22.4628C37.4522 22.4628 37.8711 22.0439 37.8292 21.4993C37.3684 14.3777 31.6711 8.68038 24.5495 8.21957Z'
                  fill='#FF4B32'
                />
                <path
                  d='M24.4658 14.4196C28.2361 14.7966 31.2523 17.8128 31.6293 21.625C31.6712 22.0858 32.0483 22.4209 32.5091 22.4209C33.0118 22.4209 33.4307 21.9601 33.3888 21.4574C32.928 16.8074 29.2415 13.079 24.5915 12.6182C24.005 12.5763 23.5023 13.1209 23.6699 13.7493C23.7537 14.1682 24.0888 14.3777 24.4658 14.4196Z'
                  fill='#FF4B32'
                />
              </svg>
            </a>
          </div>
          <div className='flex w-full cursor-pointer flex-col items-center justify-center rounded-full py-1 text-center'>
            {isComponentVisible && <IconChatClose />}
          </div>
        </div>
      </DrawChat>
      <div
        onClick={() => setIsComponentVisible(true)}
        className='block z-[999] fixed bottom-[80px] right-3'
      >
        {!isComponentVisible && <IconChat />}
      </div>
    </>
  )
}

export default PopupChat
